<div class="claims-wrapper">
  <div class="claims-header" (click)="redirectToHomePage()">
    <img src="../../../../assets/images/arrow-right.png" alt="">
    Policy Benefits
  </div>

  <div class="claims-body">
    <mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z4">
      <mat-tab label="Health Covers">

        <div class="policy-doc-body">
            <section class="banner-wrapper">
                <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/swiggy-banner.jpeg" class="banner-img" alt="Banner">
            </section>
            <section class="py-5">
                <div class="container">
                    <h2 class="title">What is covered</h2>
                    <div class="outer-box">
                        <!-- HERO -->
                        <div class="hero-label">
                            <h4>Hero</h4>
                        </div>
                        <svg class="connector-svg desktop" viewBox="0 0 1000 150" preserveAspectRatio="none">
                            <path d="
              M100,30 
              H900 
              A30,30 0 0 1 930,60 
              V130
            " fill="none" stroke="#c8ebff" stroke-width="3" stroke-linecap="round" />
                        </svg>
                        <svg class="connector-svg mobile" viewBox="0 0 360 120" preserveAspectRatio="none">
                            <path d="
              M70,20 
              H260 
              A20,20 0 0 1 280,40 
              V90
            " fill="none" stroke="#c8ebff" stroke-width="3" stroke-linecap="round" />
                        </svg>
                        <!-- BLUE BOX -->
                        <div class="inner-box">
                            <div class="row">
                                <!-- ROW 1 -->
                                <div class="col-md-3 col-6 item">
                                    <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/hospi-cover.png" class="img-fluid">
                                    <h5>Hospitalisation<br>
                                        Covered<br>
                                        up to ₹2 Lakhs*
                                    </h5>
                                </div>
                                <div class="col-md-3 col-6 item">
                                    <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/room-rent.png" class="img-fluid">
                                    <h5>Room Rent covered<br>
                                        up to ₹2,500 (Metro) /<br>
                                        ₹2,000 (Non-Metro)<br>
                                        ICU on Actuals</h5>
                                </div>
                                <div class="col-md-3 col-6 item">
                                    <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/accident.png" class="img-fluid">
                                    <h5>Up to ₹10 Lakhs in<br>
                                        case of Disablement<br>
                                        due to Accident</h5>
                                </div>
                                <div class="col-md-3 col-6 item">
                                    <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/accidental-death.png" class="img-fluid">
                                    <h5>₹10 Lakhs in<br>
                                        case of Accidental<br>
                                        Death</h5>
                                </div>
                            </div>
                            <div class="row">
                                <!-- ROW 2 -->
                                <div class="col-md-3 col-6 item">
                                    <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/pre-post.png" class="img-fluid">
                                    <h5>Pre & Post<br>
                                        Hospitalisation Bills<br>
                                        Covered</h5>
                                </div>
                                <div class="col-md-3 col-6 item">
                                    <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/opd.png" class="img-fluid">
                                    <h5>₹10,000 in case<br>
                                        of Accidental OPD<br>
                                        Expense</h5>
                                </div>
                                <div class="col-md-3 col-6 item">
                                    <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/education.png" class="img-fluid">
                                    <h5>Education Grant of ₹25,000<br>
                                        in case of Accidental Death<br>
                                        (for 2 children)</h5>
                                </div>
                                <div class="col-md-3 col-6 item">
                                    <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/loss.png" class="img-fluid">
                                    <h5>Loss of Pay# in<br>
                                        case of<br>
                                        Hospitalisation</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section">
                <div class="container">
                    <div class="row">
                        <!-- ⭐ STAR -->
                        <div class="col-lg-6 col-12 mb-3">
                            <div class="plan-wrapper star">
                                <div class="tag">
                                    <h4>Star</h4>
                                </div>
                                <div class="between-text">All Hero benefits +</div>
                                <svg class="connector-svg" viewBox="0 0 650 150" preserveAspectRatio="none">
                                    <path d="
              M100,30 
              H500 
              A30,30 0 0 1 530,60 
              V130
            " fill="none" stroke="#8c1d18" stroke-width="3" stroke-linecap="round" />
                                </svg>
                                <div class="plan-box">
                                    <div class="plan-content">
                                        <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/genral.png" alt="Hospital Icon" class="plan-icon">
                                        <h5>General Hospitalisation Covered upto ₹50,000.</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- ⭐ SUPERSTAR -->
                        <div class="col-lg-6 col-12">
                            <div class="plan-wrapper superstar">
                                <div class="tag">
                                    <h4>Superstar</h4>
                                </div>
                                <div class="between-text">All Hero + Star benefits +</div>
                                <svg class="connector-svg" viewBox="0 0 650 150" preserveAspectRatio="none">
                                    <path d="
              M100,30 
              H500 
              A30,30 0 0 1 530,60 
              V130
            " fill="none" stroke="#0f3b82" stroke-width="3" stroke-linecap="round" />
                                </svg>
                                <div class="plan-box">
                                    <div class="plan-content">
                                        <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/genral-2.png" alt="Hospital Icon" class="plan-icon">
                                        <h5>General Hospitalisation <br>Covered up to ₹1 Lakh*</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="divider"></div>
                    <!-- ⭐ MEGASTAR -->
                    <div class="plan-wrapper megastar">
                        <div class="tag">
                            <h4>Megastar</h4>
                        </div>
                        <div class="between-text">All Hero + Star + Superstar benefits +</div>
                        <svg class="connector-svg mobile mobile-wide" viewBox="0 0 350 120" preserveAspectRatio="none">
                            <path d="
              M30,20 
              H200 
              A15,15 0 0 1 215,35 
              V90
            " fill="none" stroke="#9c2626" stroke-width="3" stroke-linecap="round" />
                        </svg>
                        <svg class="connector-svg desktop" viewBox="0 0 1200 150" preserveAspectRatio="none">
                            <path d="
              M100,30 
              H700 
              A30,30 0 0 1 730,60 
              V130
            " fill="none" stroke="#9c2626" stroke-width="3" stroke-linecap="round" />
                        </svg>
                        <div class="plan-box">
                            <div class="row align-items-center">
                                <div class="col-md-5 col-12">
                                    <div class="plan-content">
                                        <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/spouse.png" alt="Hospital Icon" class="plan-icon">
                                        <h5>Coverage for DP + Spouse + 2 Children</h5>
                                    </div>
                                </div>
                                <div class="col-md-7 col-12">
                                    <div class="maternity-plan">
                                        <div class="plan-content">
                                            <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/maternity.png" alt="Maternity Icon" class="plan-icon">
                                            <div class="plan-text">
                                                <h5>Maternity</h5>
                                                <ul class="mb-0">
                                                    <li>Hospitalisation up to ₹25,000 (Normal Delivery)</li>
                                                    <li>Hospitalisation up to ₹40,000 (C-Section)</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ps-md-5 pe-md-5">
                        <p class="mt-4 mb-2">
                            *Accidental Medical Hospitalization Expenses due to Injury (applicable only for Self DEs).
                        </p>
        
                        <p>*Maternity benefits are available to all active female DEs who have completed 12 months of tenure
                            from their first order date, irrespective of their tier. </p>
        
                        <p class="mb-0">#Policy Terms and Conditions Apply. For any queries or more details, kindly reach out to
                            the
                            below-mentioned mail IDs.</p>
        
                    </div>
                </div>
            </section>
            <section class="emergency-section">
                <div class="container">
        
                    <div class="emergency-wrapper mb-5">
                        <h3 class="emergency-title">
                            What to do in case of an emergency (Cashless Claim Process)
                        </h3>
                        <p class="emergency-desc">
                            In case of a medical emergency, you can visit any IndusInd General Insurance Network Hospital and
                            opt for cashless treatment.
                        </p>
                        <ul class="emergency-list">
                            <li>The insurance company pays the hospital directly (no upfront payment by the Delivery Executive).
                            </li>
                            <li>Show your E-card and a valid photo ID at the network hospital and get admitted.</li>
                            <li> At the time of discharge, the hospital sends the complete set of claim documents to the TPA
                                desk at the hospital for processing.</li>
                            <li> Contact support immediately via<strong> Swiggy Emergency Hotline or Email: <a
                                        href="mailto:gigclaims@indusindinsurance.com"
                                        style="color: #000; text-decoration: none;">gigclaims@indusindinsurance.com</a></strong>
                            </li>
                            <li> Visit a network hospital → Show your E-Card → Hospital sends approval request →
                                Approval is usually received within 3 hours.</li>
                        </ul>
                    </div>
        
                    <div class="emergency-wrapper mb-5">
                        <h3 class="emergency-title">Reimbursement Claim Process</h3>
                        <ul class="emergency-list">
                            <li>
                                After discharge from hospital → Login to the Swiggy DE App → Go to Insurance Details → Tap on
                                Intimation of Claims.
                            </li>
                            <li>
                                Documents for Reimbursement - KYC documents | NEFT or cancelled cheque details | All hospital
                                bills and medical reports | Paid receipts | Pharmacy bills | Final discharge summary.
                            </li>
                        </ul>
                    </div>
        
                    <div class="emergency-wrapper mb-5">
                        <h3 class="emergency-title">Where to find your E-Card</h3>
                        <p class="emergency-desc mb-0">
                            Open Swiggy Delivery Executive (DE) App → Profile → Insurance Details → Download the E-Card from the
                            homepage of the Insurance section.
                        </p>
                    </div>
        
                    <div class="emergency-wrapper">
                        <h3 class="emergency-title">
                            Documents for Accidental Claims (Death)
                        </h3>
                        <p class="emergency-desc mb-0">
                            FIR copy | Post-mortem report | Legal heir certificate (if the nominee is not added) | NEFT or
                            cancelled cheque details | Death certificate | MLC/FIR for RTA cases | Nominee or KYC Documents.
                        </p>
                    </div>
                </div>
            </section>
            <section class="nominee-section">
                <div class="container">
                    <!-- TITLE -->
                    <h2 class="nominee-title mb-5">Nominee & Family Addition</h2>
                    <div class="row g-20">
                        <!-- LEFT -->
                        <div class="col-md-6">
                            <div class="nominee-card">
                                <h5>
                                    To add Family Members
                                </h5>
                                <p>
                                    • Megastar tier DPs can avail insurance coverage for their spouse and children.
                                </p>
                            </div>
                        </div>
                        <!-- RIGHT -->
                        <div class="col-md-6">
                            <div class="nominee-card">
                                <h5>
                                    To add Nominee
                                </h5>
                                <p>
                                    • Now you can directly add nominee through your DP App
                                </p>
                            </div>
                        </div>
                    </div>
                    <!-- INFO -->
                    <div class="info-row">
                        <div class="hashtag">
                            <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/fortogether.png" class="img-fluid">
                        </div>
                        <div class="contact-box">
                            To know more details:
                            <span class="phone">
                                <a href="tel:022 4890 3009">
                                    <i class="fa-solid fa-phone me-2"></i>
                                    022 4890 3009
                                </a>
                            </span>
                        </div>
                    </div>
                    <!-- EMAIL -->
                    <div class="email-bar text-center">
                        <i class="fa-solid fa-envelope"></i>
                        <a href="mailto:gigclaims@indusindinsurance.com"> gigclaims@indusindinsurance.com </a>|
                        <a href="mailto:De.insurance@swiggy.in"> De.insurance@swiggy.in </a>|
                        <a href="mailto:Insurancehelp_swiggy@marsh.com">Insurancehelp_swiggy@marsh.com </a>
                    </div>
                    <!-- NOTE -->
                    <p class="note">
                        The above are general documents; additional documents may be requested on a case-to-case basis.
                    </p>
                </div>
            </section>
            <footer class="footer-section">
                <!-- PILL -->
                <div class="footer-pill">
                    <div class="pill-item">
                        <a href="indusindinsurance.com" target="_blank"><span><img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/pointer.png"></span>
                            indusindinsurance.com</a>
                    </div>
                    <div class="pill-item">
                        <a href="tel:0224890 3009"><span><img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/phone.png"></span>022 4890 3009 (Paid)
                        </a>
                    </div>
                    <div class="pill-item">
                        <a href="https://wa.me/917400422200" target="_blank"><span><img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/whatsapp.png"></span> 74004
                            22200 (WhatsApp)</a>
                    </div>
                </div>
                <!-- BLUE -->
                <div class="footer-blue">
                    <div class="row">
                        <!-- LEFT -->
                        <div class="col-lg-10 col-12">
                            <div class="footer-bottom">
                                <p class="footer-text mb-0">
                                    Swiggy Ltd.,CIN No. U74110KA2013PTC096530 & Marsh India Insurance Brokers Pvt. Ltd., Licence
                                    No. 120, does not underwrite the risk or acts as an insurer. The General
                                    Insurance products are offered and underwritten by IndusInd General Insurance Company
                                    Limited (Formerly known as Reliance General Insurance Company Limited).
                                    Servicing of the policy and adjudication of claims is sole responsibility of IndusInd
                                    General Insurance Company Limited (Formerly known as Reliance General Insurance
                                    Company Limited) and Swiggy Ltd. and Marsh India Insurance Brokers Pvt. Ltd. cannot be held
                                    liable for the same. T&C Apply. This advertisement contains only an
                                    indication of the cover offered under Group Mediclaim UIN No.:RELHLGP21523V022021, Group
                                    Personal Accident UIN No.:RELPAGP01001V010001. For more details on
                                    risk factors, terms and conditions, brochure and exclusion, please read the policy wordings
                                    carefully before concluding a sale. IRDAI Registration No.103. IndusInd
                                    General Insurance Company Limited (Formerly known as Reliance General Insurance Company
                                    Limited). An ISO 9001:2015 Certified Company. Registered & Corporate
                                    Office: 6th Floor, Oberoi Commerz, International Business Park, Oberoi Garden City, Off.
                                    Western Express Highway, Goregaon (E), Mumbai-400063. Corporate Identity
                                    Number: U66603MH2000PLC128300. IGI/MCOM/CO/SWIGGYRIDERSINSURANCEONEPAGER/Ver.1.0/110526.
                                    Unsubscribe.
                                </p>
                            </div>
                            <div class="footer-social">
                                <a href="https://www.facebook.com/IndusIndInsurance/" target="_blank"
                                    style="margin-right: 8px; display: inline-block;">
                                    <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/facebook.png">
                                </a>
                                <a href="https://x.com/IndusIndGenIn" target="_blank"
                                    style="margin-right: 8px; display: inline-block;">
                                    <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/twitter.png">
                                </a>
                                <a href="https://www.linkedin.com/company/indusind-general-insurance/" target="_blank"
                                    style="margin-right: 8px; display: inline-block;">
                                    <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/linkedin.png">
                                </a>
                                <a href="https://www.instagram.com/indusindgenin/" target="_blank"
                                    style="margin-right: 8px; display: inline-block;">
                                    <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/insta.png">
                                </a>
                            </div>
                        </div>
                        <!-- RIGHT -->
                        <div class="col-lg-2 col-12 app-col">
                            <div class="app-image-box">
                                <div class="app-logo">
                                    <a class="app_bottom" href="https://onelink.to/5sx6eu" target="_blank"
                                        style="display: block;">
                                        <img src="https://www.indusindinsurance.com/SiteAssets/MCOM/gig-portal/download-app.png" class="img-fluid">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>

      </mat-tab>
      <!-- <mat-tab label="Accident Covers">

      </mat-tab>
      <mat-tab label="Health Covers">


      </mat-tab> -->
    </mat-tab-group>
  </div>
</div>

<!-- <div class="start-tarack-claim-wrapper" >
  <div class="button-text">Download Policy Benefits</div>
</div> -->